import Vue from 'vue'
import VueRouter from 'vue-router'
import TryoutApp from '@/components/TryoutApp.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'TryoutApp',
    component: TryoutApp,
  },
  {
    path: '/tryout/:id?',
    name: 'TryoutForm',
    component: () => import('../components/TryoutForm.vue'),
  },
]

const router = new VueRouter({
  routes,
})

export default router
